// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Status_Enum;
(function (Status_Enum) {
    Status_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    Status_Enum["NEW"] = "NEW";
    Status_Enum["SENT"] = "SENT";
    Status_Enum["NOT_SENT"] = "NOT_SENT";
    Status_Enum["DELIVERED"] = "DELIVERED";
    Status_Enum["RECEIVED"] = "RECEIVED";
    Status_Enum["FAILED_RETRYABLE"] = "FAILED_RETRYABLE";
    Status_Enum["FAILED_FATAL"] = "FAILED_FATAL";
})(Status_Enum || (Status_Enum = {}));
export var Status_Enum_index;
(function (Status_Enum_index) {
    Status_Enum_index[Status_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Status_Enum_index[Status_Enum_index["NEW"] = 1] = "NEW";
    Status_Enum_index[Status_Enum_index["SENT"] = 2] = "SENT";
    Status_Enum_index[Status_Enum_index["NOT_SENT"] = 3] = "NOT_SENT";
    Status_Enum_index[Status_Enum_index["DELIVERED"] = 4] = "DELIVERED";
    Status_Enum_index[Status_Enum_index["RECEIVED"] = 5] = "RECEIVED";
    Status_Enum_index[Status_Enum_index["FAILED_RETRYABLE"] = 8] = "FAILED_RETRYABLE";
    Status_Enum_index[Status_Enum_index["FAILED_FATAL"] = 9] = "FAILED_FATAL";
})(Status_Enum_index || (Status_Enum_index = {}));
export var Direction_Enum;
(function (Direction_Enum) {
    Direction_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    Direction_Enum["OUTBOUND"] = "OUTBOUND";
    Direction_Enum["INBOUND"] = "INBOUND";
})(Direction_Enum || (Direction_Enum = {}));
export var Direction_Enum_index;
(function (Direction_Enum_index) {
    Direction_Enum_index[Direction_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Direction_Enum_index[Direction_Enum_index["OUTBOUND"] = 1] = "OUTBOUND";
    Direction_Enum_index[Direction_Enum_index["INBOUND"] = 2] = "INBOUND";
})(Direction_Enum_index || (Direction_Enum_index = {}));
export var Provider_Enum;
(function (Provider_Enum) {
    Provider_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    Provider_Enum["TELNYX"] = "TELNYX";
    Provider_Enum["BANDWIDTH"] = "BANDWIDTH";
    Provider_Enum["DOCUMO"] = "DOCUMO";
    Provider_Enum["TWILIO"] = "TWILIO";
    Provider_Enum["WEAVE"] = "WEAVE";
    Provider_Enum["MOCK"] = "MOCK";
    Provider_Enum["RETARUS"] = "RETARUS";
    Provider_Enum["OTHER"] = "OTHER";
})(Provider_Enum || (Provider_Enum = {}));
export var Provider_Enum_index;
(function (Provider_Enum_index) {
    Provider_Enum_index[Provider_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Provider_Enum_index[Provider_Enum_index["TELNYX"] = 1] = "TELNYX";
    Provider_Enum_index[Provider_Enum_index["BANDWIDTH"] = 2] = "BANDWIDTH";
    Provider_Enum_index[Provider_Enum_index["DOCUMO"] = 3] = "DOCUMO";
    Provider_Enum_index[Provider_Enum_index["TWILIO"] = 4] = "TWILIO";
    Provider_Enum_index[Provider_Enum_index["WEAVE"] = 5] = "WEAVE";
    Provider_Enum_index[Provider_Enum_index["MOCK"] = 6] = "MOCK";
    Provider_Enum_index[Provider_Enum_index["RETARUS"] = 7] = "RETARUS";
    Provider_Enum_index[Provider_Enum_index["OTHER"] = 100] = "OTHER";
})(Provider_Enum_index || (Provider_Enum_index = {}));
export var FaxTagEvent_Enum;
(function (FaxTagEvent_Enum) {
    FaxTagEvent_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    FaxTagEvent_Enum["APPLIED"] = "APPLIED";
    FaxTagEvent_Enum["REMOVED"] = "REMOVED";
})(FaxTagEvent_Enum || (FaxTagEvent_Enum = {}));
export var FaxTagEvent_Enum_index;
(function (FaxTagEvent_Enum_index) {
    FaxTagEvent_Enum_index[FaxTagEvent_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    FaxTagEvent_Enum_index[FaxTagEvent_Enum_index["APPLIED"] = 1] = "APPLIED";
    FaxTagEvent_Enum_index[FaxTagEvent_Enum_index["REMOVED"] = 2] = "REMOVED";
})(FaxTagEvent_Enum_index || (FaxTagEvent_Enum_index = {}));
export var Webhook_Enum;
(function (Webhook_Enum) {
    Webhook_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    Webhook_Enum["QUEUED"] = "QUEUED";
    Webhook_Enum["MEDIA_PROCESSED"] = "MEDIA_PROCESSED";
    Webhook_Enum["SENDING_STARTED"] = "SENDING_STARTED";
    Webhook_Enum["DELIVERED"] = "DELIVERED";
    Webhook_Enum["FAILED"] = "FAILED";
})(Webhook_Enum || (Webhook_Enum = {}));
export var Webhook_Enum_index;
(function (Webhook_Enum_index) {
    Webhook_Enum_index[Webhook_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Webhook_Enum_index[Webhook_Enum_index["QUEUED"] = 1] = "QUEUED";
    Webhook_Enum_index[Webhook_Enum_index["MEDIA_PROCESSED"] = 2] = "MEDIA_PROCESSED";
    Webhook_Enum_index[Webhook_Enum_index["SENDING_STARTED"] = 3] = "SENDING_STARTED";
    Webhook_Enum_index[Webhook_Enum_index["DELIVERED"] = 4] = "DELIVERED";
    Webhook_Enum_index[Webhook_Enum_index["FAILED"] = 5] = "FAILED";
})(Webhook_Enum_index || (Webhook_Enum_index = {}));
export var Interval_Enum;
(function (Interval_Enum) {
    Interval_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    Interval_Enum["DAY"] = "DAY";
})(Interval_Enum || (Interval_Enum = {}));
export var Interval_Enum_index;
(function (Interval_Enum_index) {
    Interval_Enum_index[Interval_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Interval_Enum_index[Interval_Enum_index["DAY"] = 1] = "DAY";
})(Interval_Enum_index || (Interval_Enum_index = {}));
export var ScreenshotImageFormat_Enum;
(function (ScreenshotImageFormat_Enum) {
    ScreenshotImageFormat_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    ScreenshotImageFormat_Enum["JPEG"] = "JPEG";
    ScreenshotImageFormat_Enum["PNG"] = "PNG";
    ScreenshotImageFormat_Enum["WEBP"] = "WEBP";
})(ScreenshotImageFormat_Enum || (ScreenshotImageFormat_Enum = {}));
export var ScreenshotImageFormat_Enum_index;
(function (ScreenshotImageFormat_Enum_index) {
    ScreenshotImageFormat_Enum_index[ScreenshotImageFormat_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ScreenshotImageFormat_Enum_index[ScreenshotImageFormat_Enum_index["JPEG"] = 1] = "JPEG";
    ScreenshotImageFormat_Enum_index[ScreenshotImageFormat_Enum_index["PNG"] = 2] = "PNG";
    ScreenshotImageFormat_Enum_index[ScreenshotImageFormat_Enum_index["WEBP"] = 3] = "WEBP";
})(ScreenshotImageFormat_Enum_index || (ScreenshotImageFormat_Enum_index = {}));
